import HorizontalBar from 'd3vue/components/HorizontalBar.vue'
import { keepDimensions, asTree, buildCropFunction, valueAsNumber } from '../dataFilter'
import { toArray } from '../colors'
import api from '../api'

export default {
  id: 'horizontal-bar',
  label: 'Graphique en barre horizontal',
  component: HorizontalBar,
  dimensions: 1,
  multipleMeasure: () => false,
  adaptater: (data, vue) => {
    const props = {
      labelRatio: Math.min(0.4, 0.2 * Math.max(...data.map(d => d.Group0Level || 1)))
    }
    if (vue.colorScheme) {
      const colors = toArray(vue.colorScheme)
      props.color = () => colors[0]
    }
    vue.buildProps(props)
    let result = asTree(data, {
      measure: api.measure.name(vue.measure[0]),
      typed: m => valueAsNumber(m),
      measureKey: 'value',
      fallback: 0,
      normalizeExtra: node => Object.assign(node, {label: node.name})
    }).children

    if (result.every(d => !d.children || !d.children.length)) {
      result = buildCropFunction(d => d.value, vue)(result)
    }

    return result
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/HorizontalBar.js